<template>
  <transition>
    <div class="rule" v-show="show">
      <div class="tip">
        <!--                <div class="tip-title">活动规则</div>-->
        <div class="tip-content">
          <p>1、下单金额每满1100元，获得抽奖机会1次，按1100元的倍数递增对应的抽奖次数，金额低于1100元，不计入抽奖资格。</p>
          <p>2、抽取后获得积分立即返还到个人积分账户中。</p>
          <p>3、地区专享折扣用户，暂不参与线上抽奖活动。</p>
        </div>
      </div>
    </div>
  </transition>

</template>

<script>
export default {
  name: "Rule",
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      show: this.visible
    }
  },
  watch: {
    visible(to, from) {
      this.show = to
    }
  },
  mounted() {

  }
}
</script>

<style scoped lang="scss">
.rule {
  width: 100%;
  max-height: 330px;
  background-image: url(/static/img/draw_rule.png);
  background-size: 100% 100%;
  padding: 30px 10px 10px 10px;
  overflow-y: hidden;
  z-index: 10;
}

.tip {
  position: relative;
  margin: 2.5rem auto 0;
  width: 17.5rem;
  /*border: 1px solid #fbc27f;*/
}

.tip-content {
  padding: 1.5625rem 0.625rem;
  font-size: 0.875rem;
  /*color: #ffeb39;*/
  line-height: 1.5;
  /*background: #f36d56;*/
}

.tip-title {
  position: absolute;
  top: -1rem;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 1rem;
  color: #fccc6e;
  background: rgb(243, 109, 86);
  padding: 0.3125rem 0.625rem;
}

</style>



// WEBPACK FOOTER //
// Rule.vue?408f98fa